import type { FaireProductEntity } from "../../entity_types/product";

export const p_7m30xejewo: FaireProductEntity = {
  token: "p_7m30xejewo",
  type: "product",
  name: "Hunky Dory Organic Decaf, 12 oz",
  brandToken: "b_3angyj4q6y",
  brandName: "Sightglass Coffee Roasters",
  imageUrl: "https://cdn.faire.com/fastly/41269391ca74f0c810d5b171ffc282ccb382bc660b123a12a294aadf0210f175.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9bac7760c4adca906f970838ad517c6496cf5db0396c9d565b649c75715fb558.png",
    "https://cdn.faire.com/fastly/9ccf66ccd4b10f0cd7dd2ce43179cc5dd5c882b40a89225c905ea3b3dc126352.jpeg",
    "https://cdn.faire.com/fastly/443a70ba743c00b079f7e372b3cc355b79a72c0c0266c0829510f4a5b1cf40d5.jpeg",
    "https://cdn.faire.com/fastly/e136cb9c51e8bf15ed806bbf4ecc8f46f7650e750620a3d644182d77c7023bf9.jpeg"
  ],
  priceDollars: 13.25,
  description: "Hunky Dory Decaf is a faithful friend with something for everyone to love (minus the jitters from the caffeine). Not finicky about any particular brew method, the extraordinary qualities of this Swiss Water Process decaffeinated coffee shine through in every cup. We carefully adjust the blend as the seasons change to maintain the balance that has made this decaf a favorite go-to in our lineup.\n• CCOF Certified Organic\n• Taste notes // Balanced and versatile, with rich toffee sweetness and hints of red grape meet floral undertones of bergamot.\n• Roast profile // Medium-Dark\n• Recommended brew methods // Espresso, French Press, Aeropress, V60, Chemex, Kalita Wave, Cold Brew\n• Shelf life // All our whole bean coffees are roasted fresh to order and stamped with the roast date.",
  tags: [],
  msrpDollars: 21.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:43.760Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
